export default __webpack_public_path__ + "static/media/11.2de2f91c.PNG";